import { render } from "./submissionFailure.vue?vue&type=template&id=49127ae5&scoped=true"
import script from "./submissionFailure.vue?vue&type=script&lang=js"
export * from "./submissionFailure.vue?vue&type=script&lang=js"

import "./submissionFailure.vue?vue&type=style&index=0&id=49127ae5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49127ae5"]])

export default __exports__